// Constants.js
const getBaseUrl = () => {
  const hostname = window.location.hostname;
  return `https://${hostname}/`;
};

// Runtime config injected by /public/config.js (locally) or by NestJS at
// container startup (in production/staging). One build folder serves both
// environments because these values are read at runtime from the browser.
const runtimeConfig = (typeof window !== "undefined" && window.__APP_CONFIG__) || {};

const dynamicUrls = {
  UPTIME_DEFAULT_URL: runtimeConfig.UPTIME_DEFAULT_URL,
  RECAPTCHA_URL: runtimeConfig.RECAPTCHA_URL,
  COPILOT_URL: runtimeConfig.COPILOT_URL,
};

export const config_UPTIME = {
  url: {
    API_URL: `${getBaseUrl()}api/v1`,
    SOCKET_URL: getBaseUrl(),
    ...dynamicUrls,
  },
};
